module.exports = __webpack_public_path__ + "img/[转圈].d6969045.svg";